// **React Imports
import React, { memo } from 'react'

// **MUI Imports
import { Box, CircularProgress } from '@mui/material'

// **SCSS Imports
import './index.scss'

const OverlayLoading = () => {
  return (
    <Box className="loading-container">
      <CircularProgress />
    </Box>
  )
}

export default memo(OverlayLoading)
